// Das Pin-Formular unter /admin/pinterest/pins/neu: wählt der Betreiber eine
// Vorlage, kommen ihr Titel und ihre Beschreibung als Vorgabe in die Felder
// (docs/PINTEREST.md) -- die deutsche Fassung für den Pin, die englische für
// seinen Zwilling.
//
// Kein React-Komponent, aus demselben Grund wie der Kopieren-Knopf: die Seite
// ist server-gerendert, und Inline-JavaScript verbietet die CSP. Die Vorgaben
// selbst rechnet der Server (`PinterestPin.defaults_for`, schon gekürzt) und
// hängt sie als `data-pin-title`/`data-pin-description` (und `-en`) an jede Option; hier
// wird nur entschieden, ob ein Feld sie übernimmt.

/**
 * Der Wert, den ein Feld nach dem Umwählen trägt.
 *
 * Übernommen wird die neue Vorgabe nur, wenn das Feld leer ist oder noch die
 * Vorgabe der vorher gewählten Vorlage enthält -- was der Betreiber selbst
 * getippt hat, überschreibt ein Klick in der Auswahl nicht.
 */
export function nextFieldValue(current: string, previousDefault: string | undefined, nextDefault: string): string {
  return current === '' || current === previousDefault ? nextDefault : current
}

type DefaultedField = HTMLInputElement | HTMLTextAreaElement

const FIELDS = [
  { selector: '#pinterest_pin_title', key: 'pinTitle' },
  { selector: '#pinterest_pin_description', key: 'pinDescription' },
  { selector: '#pinterest_pin_title_en', key: 'pinTitleEn' },
  { selector: '#pinterest_pin_description_en', key: 'pinDescriptionEn' },
] as const

function selectedDefault(select: HTMLSelectElement, key: (typeof FIELDS)[number]['key']): string {
  return select.selectedOptions[0]?.dataset[key] ?? ''
}

export function startPinterestPinForm(root: ParentNode = document): void {
  const select = root.querySelector<HTMLSelectElement>('[data-pin-template-select]')
  const form = select?.form
  if (!select || !form) return

  // Was die Felder jetzt als Vorgabe tragen: kam die Seite mit `?template=`,
  // hat der Server sie schon gefüllt -- dann zählt dieser Inhalt als Vorgabe
  // und darf beim Umwählen ersetzt werden.
  const defaults = new Map<DefaultedField, string>()
  for (const { selector, key } of FIELDS) {
    const field = form.querySelector<DefaultedField>(selector)
    if (field && field.value === selectedDefault(select, key)) defaults.set(field, field.value)
  }

  select.addEventListener('change', () => {
    for (const { selector, key } of FIELDS) {
      const field = form.querySelector<DefaultedField>(selector)
      if (!field) continue

      const next = selectedDefault(select, key)
      field.value = nextFieldValue(field.value, defaults.get(field), next)
      if (field.value === next) defaults.set(field, next)
      // Der Zeichenzähler (ui/characterCounter.ts) hört auf `input`.
      field.dispatchEvent(new Event('input', { bubbles: true }))
    }
  })
}
